import FetchClient from "./FetchClient";
import { type StoreProductResult } from "./ProductSearchService";

export interface SearchHistoryEntry {
  userId: string;
  timestamp: number;
  retailer: string;
  sku: string;
  name: string;
  imageUrl: string;
  results: StoreProductResult[];
}

export interface SearchHistoryResponse {
  items: SearchHistoryEntry[];
  nextCursor?: string;
  hasMore: boolean;
}

export async function getSearchHistory(
  limit: number = 20,
  cursor?: string,
  retailer?: string
): Promise<SearchHistoryResponse> {
  const params = new URLSearchParams();
  params.append("limit", limit.toString());
  if (cursor) params.append("cursor", cursor);
  if (retailer) params.append("retailer", retailer);
  
  const response = await FetchClient.get<{ data: SearchHistoryResponse }>(`/search-history?${params.toString()}`);
  return response.data;
}
